import React, { SVGAttributes } from 'react';

const SvgArrow = ({
  style,
  onClick,
}: {
  style: string;
  onClick?: () => void;
}) => {
  return (
    <svg
      onClick={onClick}
      width="25"
      height="15"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5861 8.0858C18.1956 7.69528 17.5624 7.69528 17.1719 8.0858L11.879 13.3787L6.58609 8.0858C6.19556 7.69528 5.5624 7.69528 5.17187 8.0858L4.46477 8.79291C4.07424 9.18343 4.07424 9.8166 4.46477 10.2071L10.8183 16.5607C11.4041 17.1465 12.3539 17.1465 12.9396 16.5607L19.2932 10.2071C19.6837 9.8166 19.6837 9.18343 19.2932 8.79291L18.5861 8.0858Z"
      />
    </svg>
  );
};
export { SvgArrow };
